import React from 'react'
import {loginAuthMenu, signupAuthMenu, confirmAuthMenu, showResetAuthMenu, resetAuthMenu, routesUrls} from "../../settings/routes"
import Auth from '../common/Auth'
import HandleConfirm from '../common/Auth/HandleConfirm'
import HandleReset from '../common/Auth/HandleReset'
import Login from '../common/Auth/Login'
import Signup from '../common/Auth/Signup'
import Reset from '../common/Auth/Reset'
import queryString from 'query-string'
import {Redirect} from 'react-router-dom'


const AuthPage = (props) => {
    let {match : {params : {menu}}, location : {search}} = props

    let AuthComponent
    let componentProps = {}

    switch (menu) {
        case loginAuthMenu : {
            AuthComponent = Login
            break
        }
        case signupAuthMenu : {
            AuthComponent = Signup
            break
        }
        // case confirmAuthMenu : {
        //     let {id, key : token} = queryString.parse(search)
        //     componentProps = {
        //         ...componentProps,
        //         id,
        //         token
        //     }
        //     AuthComponent = HandleConfirm
        //     break
        // }
        case resetAuthMenu : {
            let {token} = queryString.parse(search)
            componentProps = {
                ...componentProps,
                token
            }
            AuthComponent = HandleReset
            break
        }
        case showResetAuthMenu : {
            AuthComponent = Reset
            break
        }
        default : {
            return <Redirect to={routesUrls.notFound}/>
        }
    }
    return (
        <Auth>
            {
                AuthComponent && <AuthComponent {...componentProps} />
            }
        </Auth>
    )
}

export default AuthPage


// WEBPACK FOOTER //
// ./yii2/frontend/frontend-assets/src/components/routes/AuthPage.js